export default interface IValidationRules {
  required: any;
  email: any;
  minLenght(qtt: number): any;
}

export const rules: IValidationRules = {
  required: (value: any) => !!value || "Required.",
  minLenght(qtt: number) {
    return (value: any) =>
      (!!value && value.length > qtt) || "Insert at least " + qtt + " chars";
  },
  email: (v: any) => (!!v && /.+@.+\..+/.test(v)) || "Email is invalid"
};
